module.exports = __webpack_public_path__ + "img/location-buildings-bbva-branch.e1a4a9cf.svg";